function initConseilsProduits() {
  const section = document.querySelector('.bloc-selection-conseils');
  const cheveux = document.getElementById('cheveux');
  const effet = document.getElementById('effet');
  const container = document.getElementById('produits-bloc-conseils');
  

  if (!section || !cheveux || !effet || !container) {
    return setTimeout(initConseilsProduits, 200);
  }

  function updateProduits() {
    const valCheveux = cheveux.value;
    const valEffet = effet.value;

    console.log("Sélection :", valCheveux, valEffet);

    // Cacher tous les blocs produits
    document.querySelectorAll("[id^='produits-bloc-option']")
      .forEach(bloc => bloc.classList.remove("show"));

    // Cacher le conteneur global au départ
    container.classList.remove("visible");

    // Mapping des combinaisons
    const mapping = {

      //Cheveux fins
      "1-1": "produits-bloc-option1",
      "1-2": "produits-bloc-option2",
      "1-3": "produits-bloc-option3",
      "1-4": "produits-bloc-option10",

      //Cheveux moyens
      "2-1": "produits-bloc-option4",
      "2-2": "produits-bloc-option5",
      "2-3": "produits-bloc-option6",
      "2-4": "produits-bloc-option11",

      //Cheveux épais
      "3-1": "produits-bloc-option7",
      "3-2": "produits-bloc-option8",
      "3-3": "produits-bloc-option9",
      "3-4": "produits-bloc-option12"
    };

    const key = `${valCheveux}-${valEffet}`;
    const blocId = mapping[key];

    if (blocId) {
      const bloc = document.getElementById(blocId);
      if (bloc) {
        bloc.classList.add("show");
        container.classList.add("visible");
      }
    }
  }

  cheveux.addEventListener("change", updateProduits);
  effet.addEventListener("change", updateProduits);
}

initConseilsProduits();